export default "__VITE_ASSET__riJaUYxh__"